<template>
	<v-card class="mt-3">
		<v-dialog v-model="dialogConfirmacao" persistent>
			<v-card class="pa-5">
				<v-card-title class="text-h5">
					<span class="mx-auto">Confirmar alteração de meta?</span>
				</v-card-title>
				<div class="text-center py-3">
					<v-icon size="100" color="red">mdi-help-circle-outline</v-icon>
				</div>
				<v-card-text class="text-h6 text-center">Ao clicar em OK, você confirma que deseja alterar as metas da
					filial</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="red" elevation="0" class="px-5" dark
						@click="dialogConfirmacao = false">Cancelar</v-btn>
					<v-btn color="primary" elevation="0" class="px-10"
						@click="definirMeta(), dialogConfirmacao = false">OK</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialog.status" persistent max-width="575px">
			<CardDialog :dialog="dialog" />
		</v-dialog>
    <v-dialog v-model="dialogExportacao" persistent max-width="575px">
      <v-card class="pa-5">
        <v-card-title class="text-h5">
          <span class="mx-auto">Confirmação de Período</span>
        </v-card-title>
        <div class="text-center py-3">
          <v-icon size="100" color="red">mdi-help-circle-outline</v-icon>
        </div>
        <v-card-text class="text-h6 text-center">Ao clicar em OK, você confirma a exportação de metas de todas as filiais dentro do período de
          {{formataData(busca.dtini)}} à {{formataData(busca.dtfim)}}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" elevation="0" class="px-5" dark
                 @click="dialogExportacao = false">Cancelar</v-btn>
          <v-btn color="primary" elevation="0" class="px-10"
                 @click="exportaPlanilhaTudoPeriodo">OK</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
		<v-row class="px-3 px-lg-0 mb-n7">
			<v-col class="d-none d-md-block">
				<v-card-title class="py-1">Definir metas</v-card-title>
			</v-col>
      <div class="pt-5 ">
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon left color="primary" style="cursor: pointer;"
                    @click="filtrosPersonalizados = !filtrosPersonalizados"
                    v-bind="attrs"
                    v-on="on"
            >
              mdi-filter-variant</v-icon>
          </template>
          <span>Filtros adicionais para exportação personalizada</span>
        </v-tooltip>
      </div>
			<v-col cols="6" md="3" class="px-3 px-md-1 mb-n7 mb-md-0">
				<v-autocomplete :items="filiaisFiltro" item-text="filial" item-value="idfilial" label="Filial" outlined
					dense :disabled="carregando" v-model="busca.idfilial"
					@change="listarConfiguracaoMeta(), listar()"></v-autocomplete>
			</v-col>
			<v-col cols="6" md="3" class="px-3 px-md-1">
				<InputDatePicker type="month" :disabled="carregando" v-model="busca.dtmes" label="Data" :outlined="true"
					:dense="true" />
			</v-col>
			<v-col cols="12" md="3" class="px-3 px-md-1 mr-0 mr-md-5">
				<v-text-field :disabled="carregando" v-model="metaFilial" label="Meta Filial" outlined dense
					@blur="meta()" />
			</v-col>
		</v-row>
    <transition name="fade">
      <v-row v-show="filtrosPersonalizados" class="px-3 px-lg-0">
        <v-col class="d-none d-md-block"></v-col>
        <v-col cols="6" md="3" class="px-3 px-md-1 mb-n7 mb-md-0"></v-col>

        <!-- Alinha com o campo 'Meta Filial' -->
        <v-col cols="6" md="3" class="pt-0 px-md-1">
          <InputDatePicker
              :disabled="carregando"
              v-model="busca.dtini"
              label="Data Início"
              :outlined="true"
              :dense="true"
          />
        </v-col>

        <v-col cols="6" md="3" class="pt-0 pb-6 px-md-1 mr-0 mr-md-5">
          <InputDatePicker
              :disabled="carregando"
              v-model="busca.dtfim"
              label="Data Fim"
              :outlined="true"
              :dense="true"
          />
        </v-col>
      </v-row>
    </transition>

		<v-divider />
		<v-progress-linear indeterminate absolute :active="carregando" />
		<v-card-text class="pa-0">
			<p class="text-center text-h6 mt-5" v-if="dados.vendedores.length == 0">Selecione uma filial para listar as
				metas.</p>
			<v-simple-table v-else>
				<thead v-if="dados.mesmetaheader">
					<tr>
						<th></th>
						<th>Vendedor</th>
						<th class="meses-bg">
							<div class="d-flex align-center justify-space-between">
								<v-tooltip top color="primary">
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon x-small color="primary" :disabled="exibirMesesAnteriores"
											v-bind="attrs" v-on="on" @click="exibirMesesAnteriores = true">
											<v-icon small>mdi-chevron-left</v-icon>
										</v-btn>
									</template>
									<span>Ver os 3 meses anteriores</span>
								</v-tooltip>
								<span>Meta {{ dados.mesmetaheader[mesesExibidos[0]] }}</span>
							</div>
						</th>
						<th class="meses-bg text-center">Meta {{ dados.mesmetaheader[mesesExibidos[1]] }}</th>
						<th class="meses-bg">
							<div class="d-flex align-center justify-space-between">
								<span>Meta {{ dados.mesmetaheader[mesesExibidos[2]] }}</span>
								<v-tooltip top color="primary">
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon x-small color="primary" :disabled="!exibirMesesAnteriores"
											v-bind="attrs" v-on="on" @click="exibirMesesAnteriores = false">
											<v-icon small>mdi-chevron-right</v-icon>
										</v-btn>
									</template>
									<span>Ver os 3 meses mais recentes</span>
								</v-tooltip>
							</div>
						</th>
						<th class="text-center">
							Média Realizado
							<v-tooltip top color="primary">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="grey darken-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
								</template>
								<span>Calculada sobre os últimos 6 meses</span>
							</v-tooltip>
						</th>
						<th class="text-center">Fixar valor</th>
						<th class="text-center">
							Ajuste da Meta (%)
							<v-tooltip top color="primary">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="grey darken-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
								</template>
								<span>Percentual da meta acima ou abaixo da média realizada. Ao alterar, trava esse vendedor e recalcula o rateio dos demais</span>
							</v-tooltip>
						</th>
						<th>Meta</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="dados.vendedores">
						<template v-for="(u, i) in vendedoresExibidos">
							<tr :key="i" :class="{
								'oculto-borda-lateral': mostrarOcultos && i >= vendedoresAtivos.length,
								'oculto-borda-base': mostrarOcultos && i === vendedoresExibidos.length - 1 && !(u.dataDemissao || u.observacao)
							}">
								<td class="pr-0">
									<v-tooltip top color="primary">
										<template v-slot:activator="{ on, attrs }">
											<v-btn fab text x-small v-bind="attrs" v-on="on" @click="ocultarVendedor(u)">
												<v-icon>{{ estaOculto(u) ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
											</v-btn>
										</template>
										<span>{{ estaOculto(u) ? "Mostrar vendedor na lista" : "Ocultar vendedor da lista" }}</span>
									</v-tooltip>
								</td>
								<td class="text-truncate" style="max-width: 250px;">
									<v-icon color="red"
										v-if="u.grupo == 63 || u.grupo == 155">mdi-account-alert-outline</v-icon>
									{{ u.vendedor }}
									<br />
									<small>
										<strong>ID:</strong>
										{{ u.idvendedor }}
									</small>
									<small class="ml-3">
										<strong>Admissão:</strong>
										{{ u.dataadmissao }}
									</small>
								</td>
								<td class="text-truncate meses-bg">
									{{ u.metas[mesesExibidos[0]] | formataDinheiro }}
									<v-chip class="mt-1 font-weight-bold float-right" x-small
										:color="porcentagemMetaRealizada(u.realizadaspercentual[mesesExibidos[0]])">{{
											u.realizadaspercentual[mesesExibidos[0]].toFixed(1) }}%</v-chip>
									<br />
									<small>
										<strong>Realizado:</strong>
										{{ u.realizas[mesesExibidos[0]] | formataDinheiro }}
									</small>
								</td>
								<td class="text-truncate meses-bg">
									{{ u.metas[mesesExibidos[1]] | formataDinheiro }}
									<v-chip class="mt-1 font-weight-bold float-right" x-small
										:color="porcentagemMetaRealizada(u.realizadaspercentual[mesesExibidos[1]])">{{
											u.realizadaspercentual[mesesExibidos[1]].toFixed(1) }}%</v-chip>
									<br />
									<small>
										<strong>Realizado:</strong>
										{{ u.realizas[mesesExibidos[1]] | formataDinheiro }}
									</small>
								</td>
								<td class="text-truncate meses-bg">
									{{ u.metas[mesesExibidos[2]] | formataDinheiro }}
									<v-chip class="mt-1 font-weight-bold float-right" x-small
										:color="porcentagemMetaRealizada(u.realizadaspercentual[mesesExibidos[2]])">{{
											u.realizadaspercentual[mesesExibidos[2]].toFixed(1) }}%</v-chip>
									<br />
									<small>
										<strong>Realizado:</strong>
										{{ u.realizas[mesesExibidos[2]] | formataDinheiro }}
									</small>
								</td>
								<td class="text-center">{{ u.mediaRealizado | formataDinheiro }}</td>
								<td class="text-center">
									<v-checkbox v-model="u.fixar" class="d-inline-block" />
								</td>
								<td class="text-center">
									<v-text-field v-if="u.mediaRealizado > 0" v-model.number="u.variacaoInput" type="number"
										outlined dense hide-details suffix="%" style="max-width: 100px; margin: 0 auto;"
										:disabled="carregando" @change="alterarPercentualMeta(u)" />
									<span v-else class="grey--text">—</span>
								</td>
								<td class="text-truncate">
									<v-text-field :color="u.dataDemissao ? 'red' : ''" outlined hide-details
										style="min-width: 120px" :disabled="carregando" v-model="u.meta" dense
										:append-icon="u.dataDemissao ? 'mdi-alert-octagon-outline' : ''"
										@change="u.fixar = true, metaVendedor()" />
								</td>
							</tr>
							<tr v-if="u.dataDemissao || u.observacao || u.grupo == 155" :key="'v_' + u.idvendedor" class="py-0" :class="{
								'oculto-borda-lateral': mostrarOcultos && i >= vendedoresAtivos.length,
								'oculto-borda-base': mostrarOcultos && i === vendedoresExibidos.length - 1
							}">
								<td colspan="9" class="text-truncate py-0"
									style="height: 30px !important;">
									<small>
										<strong class="mr-2">Observação -</strong>
										<template v-if="u.grupo == 155">Cargo de gerente</template>
										<template v-if="u.grupo == 155 && u.dataDemissao">-</template>
										<template v-if="u.dataDemissao">
											<strong>Demissão:</strong>
											{{ u.dataDemissao }}
										</template>
										<template v-if="(u.dataDemissao || u.grupo == 155) && u.observacao">-</template>
										<template v-if="u.observacao">{{ u.observacao }}</template>
									</small>
								</td>
							</tr>
							<tr v-if="i === vendedoresAtivos.length - 1 && vendedoresOcultosLista.length > 0"
								:key="'divisor_' + i" class="grey lighten-3"
								:class="{ 'oculto-borda-lateral oculto-borda-topo': mostrarOcultos }">
								<td colspan="9" class="pa-0" style="height: auto;">
									<v-btn text small block color="primary" class="ma-0" style="height: 32px;"
										@click="mostrarOcultos = !mostrarOcultos">
										<v-icon left small>{{ mostrarOcultos ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
										{{ mostrarOcultos ? "Recolher Vendedores Ocultos" : `Exibir Vendedores Ocultos (${vendedoresOcultosLista.length})` }}
									</v-btn>
								</td>
							</tr>
						</template>
					</template>
					<template v-else>
						<tr>
							<td class="text-center" colspan="9">Nenhum registro encontrado.</td>
						</tr>
					</template>
				</tbody>
				<tfoot v-if="dados.vendedores">
					<tr>
						<td></td>
						<td class="font-weight-bold">Total</td>
						<td class="font-weight-bold text-truncate meses-bg">
							{{ dados.total.metas[mesesExibidos[0]] | formataDinheiro }}
							<v-chip class="ml-1 font-weight-bold float-right" x-small
								:color="porcentagemMetaRealizada(dados.total.realizadaspercentual[mesesExibidos[0]])">{{
									dados.total.realizadaspercentual[mesesExibidos[0]].toFixed(2) }}%</v-chip>
							<br />
							<small>
								<strong>Realizado:</strong>
								{{ dados.total.realizas[mesesExibidos[0]] | formataDinheiro }}
							</small>
						</td>
						<td class="font-weight-bold text-truncate meses-bg">
							{{ dados.total.metas[mesesExibidos[1]] | formataDinheiro }}
							<v-chip class="ml-1 font-weight-bold float-right" x-small
								:color="porcentagemMetaRealizada(dados.total.realizadaspercentual[mesesExibidos[1]])">{{
									dados.total.realizadaspercentual[mesesExibidos[1]].toFixed(2) }}%</v-chip>
							<br />
							<small>
								<strong>Realizado:</strong>
								{{ dados.total.realizas[mesesExibidos[1]] | formataDinheiro }}
							</small>
						</td>
						<td class="font-weight-bold text-truncate meses-bg">
							{{ dados.total.metas[mesesExibidos[2]] | formataDinheiro }}
							<v-chip class="ml-1 font-weight-bold float-right" x-small
								:color="porcentagemMetaRealizada(dados.total.realizadaspercentual[mesesExibidos[2]])">{{
									dados.total.realizadaspercentual[mesesExibidos[2]].toFixed(2) }}%</v-chip>
							<br />
							<small>
								<strong>Realizado:</strong>
								{{ dados.total.realizas[mesesExibidos[2]] | formataDinheiro }}
							</small>
						</td>
						<td></td>
						<td></td>
						<td></td>
						<td class="font-weight-bold text-truncate text-body-1">{{ totalMetaVendedor | formataDinheiro }}
						</td>
					</tr>
				</tfoot>
			</v-simple-table>
		</v-card-text>
		<v-divider />
		<v-card-actions class="pa-4" style="gap: 12px;">
			<v-spacer />
      <transition name="fade">
        <v-btn outlined class="py-5" :disabled="carregando" color="primary" @click="dialogExportacao = true" v-show="filtrosPersonalizados">
          <v-icon class="pr-0 pr-md-2">mdi-file-excel-outline</v-icon>
          <span class="d-none d-md-block">Exportação personalizada</span>
        </v-btn>
      </transition>
			<v-btn outlined class="py-5" :disabled="carregando" color="primary" @click="exportaPlanilhaTudo()">
				<v-icon class="pr-0 pr-md-2">mdi-file-excel-outline</v-icon>
				<span class="d-none d-md-block">Exportar Todas Filiais</span>
			</v-btn>
			<v-btn outlined class="py-5" :disabled="carregando" color="primary" @click="exportaPlanilha()">
				<v-icon class="pr-0 pr-md-2">mdi-file-excel-outline</v-icon>
				<span class="d-none d-md-block">Exportar em Excel</span>
			</v-btn>
			<v-btn v-if="dados.metadefinida" class="py-5" :disabled="carregando" color="primary" elevation="2"
				@click="dialogConfirmacao = true">
				<v-icon class="pr-0 pr-md-2">mdi-content-save-outline</v-icon>
				<span class="d-none d-md-block">Definir Meta</span>
			</v-btn>
			<v-btn v-else class="py-5" :disabled="carregando" color="primary" elevation="2" @click="definirMeta()">
				<v-icon class="pr-0 pr-md-2">mdi-content-save-outline</v-icon>
				<span class="d-none d-md-block">Definir Meta</span>
			</v-btn>
		</v-card-actions>
		<v-progress-linear indeterminate absolute :active="carregando" />
	</v-card>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../util/mixinFilial";
import InputDatePicker from "../Widgets/InputDatePicker";
import CardDialog from "../Widgets/CardDialog";

export default {
	name: "FilialDefinirMetas",
	mixins: [mixinFilial],
	components: { InputDatePicker, CardDialog },
	data: () => ({
		dialog: { status: false, title: "", msg: "", icon: "", iconColor: "" },
		dialogConfirmacao: false,
		dialogVendedores: false,
    dialogExportacao: false,
		carregando: false,
		dados: { vendedores: [] },
		configuracoes: {},
		vendedoresOcultos: {},
		exibirMesesAnteriores: false,
		mostrarOcultos: false,

    filtrosPersonalizados: false,
		busca: {
			dtmes: `${new Date().getFullYear()}-${(new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getMonth() +
				1 <
				10
				? "0"
				: "") +
				(new Date().getMonth() + 1)
				}`,
			idfilial: 0,
      dtini: `${new Date().getFullYear()}-01-01`,
      dtfim: `${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ).getFullYear()}-${
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getMonth() + 1 < 10
              ? "0"
              : ""
      }${
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getMonth() + 1
      }-${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ).getDate()}`,
		},
		metaFilial: "",
		totalMetaVendedor: 0.0,
		dataAtual: `${new Date().getFullYear()}-${(new Date(
			new Date().getFullYear(),
			new Date().getMonth() + 1,
			0
		).getMonth() +
			1 <
			10
			? "0"
			: "") +
			(new Date().getMonth() + 1)
			}-${(new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getDate() < 10
				? "0"
				: "") + new Date().getDate()
			}`,
	}),
	computed: {
		...mapState(["backendUrl", "pgLimit", "usuario"]),
		filiaisFiltro() {
			if (this.filiais.lista) {
				return this.filiais.lista.filter((v) => {
					return (
						v.idfilial != 4 &&
						v.idfilial != 6 &&
						v.idfilial != 12 &&
						v.idfilial != 13 &&
						v.idfilial != 25 &&
						v.idfilial != 28 &&
						v.idfilial != 29 &&
						v.idfilial != 33 &&
						v.idfilial != 39 &&
						v.idfilial != 40 &&
						v.idfilial != 43 &&
						v.idfilial != 46 &&
						v.idfilial != 37
					);
				});
			} else {
				return [];
			}
		},
		mesesExibidos() {
			return this.exibirMesesAnteriores ? [0, 1, 2] : [3, 4, 5];
		},
		vendedoresAtivos() {
			const lista = (this.dados.vendedores || []).filter((v) => !this.estaOculto(v));
			const gerentes = lista.filter((v) => v.grupo == 155);
			const outros = lista.filter((v) => v.grupo != 155);
			return [...outros, ...gerentes];
		},
		vendedoresOcultosLista() {
			const lista = (this.dados.vendedores || []).filter((v) => this.estaOculto(v));
			const gerentes = lista.filter((v) => v.grupo == 155);
			const demitidos = lista.filter((v) => v.grupo != 155 && v.dataDemissao);
			const manuais = lista.filter((v) => v.grupo != 155 && !v.dataDemissao);
			return [...gerentes, ...demitidos, ...manuais];
		},
		vendedoresExibidos() {
			return this.mostrarOcultos
				? [...this.vendedoresAtivos, ...this.vendedoresOcultosLista]
				: this.vendedoresAtivos;
		},
	},
	methods: {
		listar() {
			if (!this.busca.idfilial) return;
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}comissao/meta/listar`, {
					periodo: this.busca.dtmes || null,
					idfilial: this.busca.idfilial || null,
				})
				.then((res) => {
					this.dados = res.data;
					this.metaFilial = 0;
					this.totalMetaVendedor = 0;
					this.vendedoresOcultos = {};
					if (!this.dados.vendedores) {
						this.dados.vendedores = [];
					}
					this.dados.vendedores.forEach((v) => {
						if (v.ocultomanualmente === true || v.ocultomanualmente === false) {
							this.$set(this.vendedoresOcultos, v.cpf, v.ocultomanualmente);
						}
						let dataAdmissao = new Date(
							v.dataadmissao.split("/").reverse().join("-")
						).getTime();
						let dataAtual = new Date(this.dataAtual).getTime();
						let diff = Math.abs(dataAdmissao - dataAtual);
						let days = Math.ceil(diff / (1000 * 60 * 60 * 24));
						let month = days / 30;
						v.meses = month;

						let ano = parseInt(this.busca.dtmes.split("-")[0]);
						let mes = parseInt(this.busca.dtmes.split("-")[1]);

						let ultimoDiaMes = new Date(
							new Date(ano, mes).getFullYear(),
							new Date(ano, mes).getMonth(),
							0
						).getDate();
						let dataUltimoDiaMes = new Date(
							this.busca.dtmes + "-" + ultimoDiaMes + " 00:00:00"
						).getTime();
						let dataPrimeiroDiaMes = new Date(
							this.busca.dtmes + "-01 00:00:00"
						).getTime();

						let diffMounth = Math.abs(
							dataPrimeiroDiaMes - dataUltimoDiaMes
						);
						let daysMounth = Math.ceil(
							diffMounth / (1000 * 60 * 60 * 24) + 1
						);

						if (v.dataInicioFerias && v.dataFimFerias) {
							let dataIniFerias = new Date(
								v.dataInicioFerias
									.split("/")
									.reverse()
									.join("-")
							).getTime();
							let dataFinFerias = new Date(
								v.dataFimFerias.split("/").reverse().join("-")
							).getTime();

							if (
								dataIniFerias >= dataPrimeiroDiaMes &&
								dataIniFerias <= dataUltimoDiaMes &&
								dataFinFerias >= dataPrimeiroDiaMes &&
								dataFinFerias <= dataUltimoDiaMes
							) {
								let diff = Math.abs(
									dataFinFerias - dataIniFerias
								);
								v.diasdeferias =
									Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
								v.diastrabalhados = daysMounth - v.diasdeferias;
							} else if (
								dataIniFerias >= dataPrimeiroDiaMes &&
								dataIniFerias <= dataUltimoDiaMes
							) {
								let diff = Math.abs(
									dataUltimoDiaMes - dataIniFerias
								);
								v.diasdeferias = Math.ceil(
									diff / (1000 * 60 * 60 * 24)
								);
								v.diastrabalhados = daysMounth - v.diasdeferias;
							} else if (
								dataFinFerias >= dataPrimeiroDiaMes &&
								dataFinFerias <= dataUltimoDiaMes
							) {
								let diff = Math.abs(
									dataFinFerias - dataPrimeiroDiaMes
								);
								v.diasdeferias =
									Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
								v.diastrabalhados = daysMounth - v.diasdeferias;
							} else {
								v.diasdeferias = 0;
								v.diastrabalhados = daysMounth;
							}
						} else {
							v.diasdeferias = 0;
							v.diastrabalhados = daysMounth;
						}

						v.fixar = false;
						if (v.meta) {
							this.metaFilial += v.meta;
							this.totalMetaVendedor += v.meta;
							v.meta = parseFloat(v.meta).toLocaleString(
								"pt-br",
								{ style: "currency", currency: "BRL" }
							);
						} else {
							v.meta = 0;
							v.meta = parseFloat(v.meta).toLocaleString(
								"pt-br",
								{ style: "currency", currency: "BRL" }
							);
						}
						let totalMeta = 0;
						let meses = 0;
						v.metas.forEach((v) => {
							if (v != 0) {
								totalMeta += v;
								meses++;
							}
						});
						if (totalMeta != 0) {
							v.mediaMeta = totalMeta / meses;
						} else {
							v.mediaMeta = 0;
						}

						let totalRealizado = 0;
						let mesesRealizado = 0;
						v.realizas.forEach((v) => {
							if (v > 0) {
								totalRealizado += v;
								mesesRealizado++;
							}
						});
						if (totalRealizado != 0) {
							v.mediaRealizado = totalRealizado / mesesRealizado;
						} else {
							v.mediaRealizado = 0;
						}
						let variacao = this.variacaoMeta(v);
						v.variacaoInput = variacao !== null ? Math.round(variacao * 10) / 10 : 0;
					});
					this.metaFilial = parseFloat(
						this.metaFilial
					).toLocaleString("pt-br", {
						style: "currency",
						currency: "BRL",
					});
					this.carregando = false;
				})
				.catch(() => {
					this.dados = {
						vendedores: [{ vendedor: "Welinton " }, {}],
					};
					this.carregando = false;
				});
		},
		exportaPlanilha() {
			if (!this.busca.idfilial) return;
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}comissao/meta/planilha/exportar`, {
					periodo: this.busca.dtmes || null,
					idfilial: this.busca.idfilial || null,
				})
				.then((res) => {
					this.carregando = false;
					const url = window.URL.createObjectURL(
						this.base64ToBlob(res.data)
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", "arquivo vendedores.xlsx");
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		exportaPlanilhaTudo() {
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}comissao/meta/planilha/exportar`, {
					periodo: this.busca.dtmes || null,
					idfilial: 1,
					todas: true,
				})
				.then((res) => {
					this.carregando = false;
					const url = window.URL.createObjectURL(
						this.base64ToBlob(res.data)
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", "arquivo vendedores.xlsx");
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
				.catch(() => {
					this.carregando = false;
				});
		},
    exportaPlanilhaTudoPeriodo() {
      this.dialogExportacao = false;
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}comissao/meta/planilha/exportar/periodo`, {
            idfilial: 1,
            dtini: this.busca.dtini,
            dtfim: this.busca.dtfim,
            todas: true
          })
          .then((res) => {
            this.carregando = false;
            const url = window.URL.createObjectURL(
                this.base64ToBlob(res.data)
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "arquivo vendedores geral.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.dialog.title = "Arquivo gerado!";
            this.dialog.msg =
                "Planilha gerada com sucesso! Verifique seus Downloads";
            this.dialog.icon = "mdi-check-circle-outline";
            this.dialog.iconColor = "success";
            this.dialog.status = true;
          })
          .catch(() => {
            this.dialog.title = "Erro";
            this.dialog.msg =
                "Erro ao gerar planilha!";
            this.dialog.icon = "mdi-alert-circle-outline";
            this.dialog.iconColor = "red";
            this.dialog.status = true;
            this.carregando = false;
          });
    },
		base64ToBlob(base64) {
			const decodedData = window.atob(base64);
			const uInt8Array = new Uint8Array(decodedData.length);
			for (let i = 0; i < decodedData.length; ++i) {
				uInt8Array[i] = decodedData.charCodeAt(i);
			}
			return new Blob([uInt8Array], { type: "text/plain" });
		},
		listarConfiguracaoMeta() {
			return axios
				.post(`${this.backendUrl}comissao/meta/configuracao`, {
					idfilial: this.busca.idfilial,
				})
				.then((res) => {
					this.configuracoes = res.data;
				});
		},
		// estaOculto decide se um vendedor fica no grupo oculto: uma sobrescrita manual (ocultar ou
		// mostrar de novo) sempre vence a regra padrão (demitido, gerente sem meta)
		estaOculto(v) {
			if (this.vendedoresOcultos[v.cpf] === true) {
				return true;
			}
			if (this.vendedoresOcultos[v.cpf] === false) {
				return false;
			}
			return !!v.dataDemissao || (v.grupo == 155 && !this.possuiMeta(v));
		},
		ocultarVendedor(u) {
			const estadoAtual = this.estaOculto(u);
			const novoEstado = !estadoAtual;
			if (novoEstado && this.possuiMeta(u)) {
				this.dialog.title = "Não é possível ocultar";
				this.dialog.msg = "Esse vendedor já tem meta lançada, por isso não pode ser ocultado da lista.";
				this.dialog.icon = "mdi-alert-circle-outline";
				this.dialog.iconColor = "red";
				this.dialog.status = true;
				return;
			}
			const rota = novoEstado ? "vendedor/ocultar" : "vendedor/mostrar";
			// atualiza a tela na hora, sem esperar o backend confirmar
			this.$set(this.vendedoresOcultos, u.cpf, novoEstado);
			axios
				.post(`${this.backendUrl}comissao/meta/${rota}`, {
					idfilial: this.busca.idfilial,
					cpf: u.cpf,
				})
				.catch(() => {
					// não salvou, desfaz a mudança na tela
					this.$set(this.vendedoresOcultos, u.cpf, estadoAtual);
					this.dialog.title = "Erro";
					this.dialog.msg = novoEstado
						? "Não foi possível ocultar o vendedor."
						: "Não foi possível mostrar o vendedor novamente.";
					this.dialog.icon = "mdi-alert-circle-outline";
					this.dialog.iconColor = "red";
					this.dialog.status = true;
				});
		},
		// variacaoMeta calcula o quanto a meta proposta subiu/baixou em relação à média realizada dos
		// últimos 6 meses. Retorna null quando não dá pra calcular (sem histórico de venda)
		variacaoMeta(u) {
			if (!u.mediaRealizado || u.mediaRealizado <= 0) {
				return null;
			}
			let metaNum = u.meta;
			if (typeof metaNum === "string") {
				metaNum = parseFloat(metaNum.replaceAll("R$", "").replaceAll(".", "").replaceAll(",", "."));
			}
			if (isNaN(metaNum)) {
				return null;
			}
			return ((metaNum - u.mediaRealizado) / u.mediaRealizado) * 100;
		},
		// alterarPercentualMeta aplica o percentual digitado sobre a média realizada do vendedor,
		// trava a meta dele (fixar) e dispara o rateio de novo pros demais
		alterarPercentualMeta(u) {
			if (!u.mediaRealizado || u.mediaRealizado <= 0) {
				return;
			}
			const novoValor = u.mediaRealizado * (1 + (u.variacaoInput || 0) / 100);
			u.meta = parseFloat(novoValor).toLocaleString("pt-br", {
				style: "currency",
				currency: "BRL",
			});
			u.fixar = true;
			this.metaVendedor();
		},
		possuiMeta(u) {
			if (typeof u.meta === "number") {
				return u.meta > 0;
			}
			if (typeof u.meta === "string") {
				const valor = parseFloat(u.meta.replaceAll("R$", "").replaceAll(".", "").replaceAll(",", "."));
				return !isNaN(valor) && valor > 0;
			}
			return false;
		},
		porcentagemMetaRealizada(porcentagem) {
			if (porcentagem < 80) {
				return "red lighten-3";
			} else if (porcentagem >= 80 && porcentagem < 100) {
				return "yellow lighten-2";
			} else {
				return "green lighten-4";
			}
		},
		metaTotal(vendedores) {
			this.totalMetaVendedor = 0;
			if (vendedores) {
				vendedores.forEach((v) => {
					if (v.meta && v.meta != "R$ NaN") {
						let sugestao = parseFloat(
							v.meta
								.replaceAll("R$", "")
								.replaceAll(".", "")
								.replaceAll(",", ".")
						);
						this.totalMetaVendedor += sugestao;
						v.meta = parseFloat(sugestao).toLocaleString("pt-br", {
							style: "currency",
							currency: "BRL",
						});
					}
				});
				this.metaFilial = parseFloat(
					this.totalMetaVendedor
				).toLocaleString("pt-br", {
					style: "currency",
					currency: "BRL",
				});
			} else {
				this.totalMetaVendedor = "";
			}
		},
		metaVendedor() {
			if (!this.dados || !Array.isArray(this.dados.vendedores)) {
				console.error("this.dados.vendedores não está definido ou não é um array.");
				return;
			}

			if (!this.configuracoes || !Array.isArray(this.configuracoes.lista)) {
				console.error("this.configuracoes.lista não está definido ou não é um array.");
				return;
			}

			try {
				this.dados.vendedores.forEach((v) => {
					if (
						v.meta == "" ||
						v.meta == "R$ NaN" ||
						v.meta == "R$ " ||
						v.meta == "R$"
					) {
						v.meta = "R$ 0,00";
					}
					v.meta = parseFloat(
						v.meta
							.replaceAll("R$", "")
							.replaceAll(".", "")
							.replaceAll(",", ".")
					);
				});
				if (this.metaFilial == "" || this.metaFilial == "R$ NaN") {
					this.metaFilial = "R$ 0,00";
				}
				this.metaFilial = parseFloat(
					this.metaFilial
						.replaceAll("R$", "")
						.replaceAll(".", "")
						.replaceAll(",", ".")
				);
				let vendedoresFixos = this.dados.vendedores.filter((v) => {
					return v.fixar;
				});
				let vendedoresGerentes = this.dados.vendedores.filter((v) => {
					return (
						!v.dataDemissao &&
						v.diasdeferias == 0 &&
						!v.fixar &&
						v.grupo == 155 &&
						this.estaOculto(v)
					);
				});
				let vendedoresDemitidos = this.dados.vendedores.filter((v) => {
					return v.dataDemissao && !v.fixar;
				});
				let vendedoresFerias = this.dados.vendedores.filter((v) => {
					return !v.dataDemissao && v.diasdeferias > 0 && !v.fixar;
				});
				let vendedoresAntigos = this.dados.vendedores.filter((v) => {
					return (
						!v.dataDemissao &&
						v.meses >
						this.configuracoes.lista
							.map((v) => v.meses)
							.reduce((a, b) => Math.max(a, b)) &&
						!v.fixar &&
						v.diasdeferias == 0 &&
						(v.grupo != 155 || !this.estaOculto(v))
					);
				});
				let vendedoresNovos = this.dados.vendedores.filter((v) => {
					return (
						!v.dataDemissao &&
						v.meses <=
						this.configuracoes.lista
							.map((v) => v.meses)
							.reduce((a, b) => Math.max(a, b)) &&
						!v.fixar &&
						v.diasdeferias == 0 &&
						(v.grupo != 155 || !this.estaOculto(v))
					);
				});
				let metaVendedores = 0;

				if (vendedoresDemitidos.length > 0) {
					vendedoresDemitidos.forEach((v) => {
						v.meta = 0;
					});
				}
				if (vendedoresNovos.length > 0) {
					vendedoresNovos.forEach((v) => {
						this.configuracoes.lista.forEach((c) => {
							if (v.meses > c.meses - 1 && v.meses <= c.meses) {
								v.meta = c.valor;
							}
						});
						metaVendedores += v.meta;
					});
				}

				if (vendedoresFerias.length > 0) {
					vendedoresFerias.forEach((v) => {
						if (v.mediaMeta > 0 && v.diastrabalhados > 0) {
							v.meta = parseFloat(
								(
									((v.mediaMeta / 30) * v.diastrabalhados) /
									10
								).toFixed(0) * 10
							);
						}
						metaVendedores += v.meta;
					});
				}

				if (vendedoresFixos.length > 0) {
					vendedoresFixos.forEach((v) => {
						metaVendedores += v.meta;
					});
				}

				if (vendedoresGerentes.length > 0) {
					vendedoresGerentes.forEach((v) => {
						metaVendedores += v.meta;
					});
				}

				if (this.metaFilial < metaVendedores) {
					this.metaFilial = metaVendedores;
				}

				let restoSobra = this.metaFilial - metaVendedores;
				let sobra = this.metaFilial - metaVendedores;

				let mediaRealizadoMesAnterior = 0;
				if (vendedoresAntigos.length > 0) {
					vendedoresAntigos.forEach((v) => {
						mediaRealizadoMesAnterior += v.mediaRealizado;
					});
				}

				if (vendedoresAntigos.length > 0) {
					vendedoresAntigos.forEach((v) => {
						v.meta = parseFloat(
							(
								(mediaRealizadoMesAnterior > 0
									? (sobra * v.mediaRealizado) / mediaRealizadoMesAnterior
									: sobra / vendedoresAntigos.length) /
								10
							).toFixed(0) * 10
						);
						restoSobra -= parseFloat(v.meta);
					});
					if (vendedoresAntigos[vendedoresAntigos.length - 1].meta != 0) {
						vendedoresAntigos[vendedoresAntigos.length - 1].meta =
							parseFloat(
								vendedoresAntigos[vendedoresAntigos.length - 1]
									.meta + restoSobra
							);
					} else {
						this.metaFilial = this.metaFilial - restoSobra;
					}
				}

				if (vendedoresAntigos.length > 0) {
					this.dados.vendedores = vendedoresAntigos;
				} else {
					this.dados.vendedores = [];
				}
				if (vendedoresDemitidos.length > 0) {
					vendedoresDemitidos.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresNovos.length > 0) {
					vendedoresNovos.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresFerias.length > 0) {
					vendedoresFerias.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresFixos.length > 0) {
					vendedoresFixos.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresGerentes.length > 0) {
					vendedoresGerentes.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}

				this.dados.vendedores.sort((a, b) => {
					return a.vendedor < b.vendedor
						? -1
						: a.vendedor > b.vendedor
							? 1
							: 0;
				});

				this.dados.vendedores.forEach((v) => {
					if (
						v.meta == "" ||
						v.meta == "R$ NaN" ||
						v.meta == "R$ " ||
						v.meta == "R$"
					) {
						v.meta = "R$ 0,00";
					} else {
						v.meta = parseFloat(v.meta).toLocaleString("pt-br", {
							style: "currency",
							currency: "BRL",
						});
					}
				});

				this.metaFilial = parseFloat(this.metaFilial).toLocaleString(
					"pt-br",
					{
						style: "currency",
						currency: "BRL",
					}
				);
				this.metaTotal(this.dados.vendedores);
				this.dados.vendedores.forEach((v) => {
					const variacao = this.variacaoMeta(v);
					v.variacaoInput = variacao !== null ? Math.round(variacao * 10) / 10 : 0;
				});
			}
			catch (error) {
				console.error("Erro ao processar os vendedores:", error);
			}
		},
		meta() {
			this.dados.vendedores.forEach((v) => {
				if (
					v.meta == "" ||
					v.meta == "R$ NaN" ||
					v.meta == "R$ " ||
					v.meta == "R$"
				) {
					v.meta = "R$ 0,00";
				}
				v.meta = parseFloat(
					v.meta
						.replaceAll("R$", "")
						.replaceAll(".", "")
						.replaceAll(",", ".")
				);
			});
			if (this.metaFilial == "" || this.metaFilial == "R$ NaN") {
				this.metaFilial = "R$ 0,00";
			}
			this.metaFilial = parseFloat(
				this.metaFilial
					.replaceAll("R$", "")
					.replaceAll(".", "")
					.replaceAll(",", ".")
			);
			if (this.metaFilial == 0) {
				this.dados.vendedores.map((v) => {
					return (v.meta = "R$ 0,00");
				});
				this.totalMetaVendedor = 0.0;
				this.metaFilial = "R$ 0,00";
			} else {
				let vendedoresFixos = this.dados.vendedores.filter((v) => {
					return v.fixar;
				});
				let vendedoresGerentes = this.dados.vendedores.filter((v) => {
					return (
						!v.dataDemissao &&
						v.diasdeferias == 0 &&
						!v.fixar &&
						v.grupo == 155 &&
						this.estaOculto(v)
					);
				});
				let vendedoresDemitidos = this.dados.vendedores.filter((v) => {
					return v.dataDemissao && !v.fixar;
				});
				let vendedoresFerias = this.dados.vendedores.filter((v) => {
					return !v.dataDemissao && v.diasdeferias > 0 && !v.fixar;
				});
				console.log(
					"chegou aqui",
					this.dados.vendedores,
					this.configuracoes.lista
				);
				let vendedoresAntigos = this.dados.vendedores.filter((v) => {
					return (
						!v.dataDemissao &&
						v.meses >
						this.configuracoes.lista
							.map((v) => v.meses)
							.reduce((a, b) => Math.max(a, b)) &&
						!v.fixar &&
						v.diasdeferias == 0 &&
						(v.grupo != 155 || !this.estaOculto(v))
					);
				});
				console.log("passou aqui");
				let vendedoresNovos = this.dados.vendedores.filter((v) => {
					return (
						!v.dataDemissao &&
						v.meses <=
						this.configuracoes.lista
							.map((v) => v.meses)
							.reduce((a, b) => Math.max(a, b)) &&
						!v.fixar &&
						v.diasdeferias == 0 &&
						(v.grupo != 155 || !this.estaOculto(v))
					);
				});
				let metaVendedores = 0;

				if (vendedoresDemitidos.length > 0) {
					vendedoresDemitidos.forEach((v) => {
						v.meta = 0;
					});
				}

				if (vendedoresNovos.length > 0) {
					vendedoresNovos.forEach((v) => {
						this.configuracoes.lista.forEach((c) => {
							if (v.meses > c.meses - 1 && v.meses <= c.meses) {
								v.meta = c.valor;
							}
						});
						metaVendedores += v.meta;
					});
				}

				if (vendedoresFerias.length > 0) {
					vendedoresFerias.forEach((v) => {
						if (v.mediaMeta > 0 && v.diastrabalhados > 0) {
							v.meta = parseFloat(
								(
									((v.mediaMeta / 30) * v.diastrabalhados) /
									10
								).toFixed(0) * 10
							);
						}
						metaVendedores += v.meta;
					});
				}

				if (vendedoresFixos.length > 0) {
					vendedoresFixos.forEach((v) => {
						metaVendedores += v.meta;
					});
				}

				if (vendedoresGerentes.length > 0) {
					vendedoresGerentes.forEach((v) => {
						metaVendedores += v.meta;
					});
				}

				if (this.metaFilial < metaVendedores) {
					this.metaFilial = metaVendedores;
				}

				let restoSobra = this.metaFilial - metaVendedores;
				let sobra = this.metaFilial - metaVendedores;

				let mediaRealizadoMesAnterior = 0;
				if (vendedoresAntigos.length > 0) {
					vendedoresAntigos.forEach((v) => {
						mediaRealizadoMesAnterior += v.mediaRealizado;
					});
				}

				if (vendedoresAntigos.length > 0) {
					vendedoresAntigos.forEach((v) => {
						v.meta = parseFloat(
							(
								(mediaRealizadoMesAnterior > 0
									? (sobra * v.mediaRealizado) / mediaRealizadoMesAnterior
									: sobra / vendedoresAntigos.length) /
								10
							).toFixed(0) * 10
						);
						restoSobra -= parseFloat(v.meta);
					});
					if (
						vendedoresAntigos[vendedoresAntigos.length - 1].meta !=
						0
					) {
						vendedoresAntigos[vendedoresAntigos.length - 1].meta =
							parseFloat(
								vendedoresAntigos[vendedoresAntigos.length - 1]
									.meta + restoSobra
							);
					} else {
						this.metaFilial = this.metaFilial - restoSobra;
					}
				}

				if (vendedoresAntigos.length > 0) {
					this.dados.vendedores = vendedoresAntigos;
				} else {
					this.dados.vendedores = [];
				}
				if (vendedoresDemitidos.length > 0) {
					vendedoresDemitidos.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresNovos.length > 0) {
					vendedoresNovos.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresFerias.length > 0) {
					vendedoresFerias.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresFixos.length > 0) {
					vendedoresFixos.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}
				if (vendedoresGerentes.length > 0) {
					vendedoresGerentes.forEach((v) => {
						this.dados.vendedores.push(v);
					});
				}

				this.dados.vendedores.sort((a, b) => {
					return a.vendedor < b.vendedor
						? -1
						: a.vendedor > b.vendedor
							? 1
							: 0;
				});

				this.dados.vendedores.forEach((v) => {
					if (
						v.meta == "" ||
						v.meta == "R$ NaN" ||
						v.meta == "R$ " ||
						v.meta == "R$"
					) {
						v.meta = "R$ 0,00";
					} else {
						v.meta = parseFloat(v.meta).toLocaleString("pt-br", {
							style: "currency",
							currency: "BRL",
						});
					}
				});

				this.metaFilial = parseFloat(this.metaFilial).toLocaleString(
					"pt-br",
					{
						style: "currency",
						currency: "BRL",
					}
				);
				this.metaTotal(this.dados.vendedores);
				this.dados.vendedores.forEach((v) => {
					const variacao = this.variacaoMeta(v);
					v.variacaoInput = variacao !== null ? Math.round(variacao * 10) / 10 : 0;
				});
			}
		},
		definirMeta() {
			let vendedores = [];
			this.dados.vendedores.forEach((v) => {
				let vendedor = {};
				vendedor.idvendedor = v.idvendedor;
				vendedor.vendedor = v.vendedor;
				if (v.meta == "R$ NaN") {
					v.meta = "R$ 0,00";
				}
				if (v.meta) {
					vendedor.meta = parseFloat(
						v.meta
							.replaceAll("R$", "")
							.replaceAll(".", "")
							.replaceAll(",", ".")
					);
				} else {
					vendedor.meta = parseFloat(0);
				}
				vendedores.push(vendedor);
			});
			return axios
				.post(`${this.backendUrl}comissao/meta/cadastrar`, {
					idfilial: this.busca.idfilial,
					periodo: this.busca.dtmes,
					metafilial: parseFloat(
						this.metaFilial
							.replaceAll("R$", "")
							.replaceAll(".", "")
							.replaceAll(",", ".")
					),
					vendedores: vendedores,
				})
				.then((res) => {
					if (res.data) {
						this.dialog.title = "Meta definida";
						this.dialog.msg =
							"Meta dos vendedores definida com sucesso!";
						this.dialog.icon = "mdi-check-circle-outline";
						this.dialog.iconColor = "success";
						this.dialog.status = true;
						this.listar();
					} else {
						this.dialog.title = "Erro";
						this.dialog.msg =
							"Não foi possível definir a meta da filial!";
						this.dialog.icon = "mdi-alert-circle-outline";
						this.dialog.iconColor = "red";
						this.dialog.status = true;
					}
				})
				.catch(() => {
					this.dialog.title = "Erro";
					this.dialog.msg =
						"Não foi possível definir a meta da filial!";
					this.dialog.icon = "mdi-alert-circle-outline";
					this.dialog.iconColor = "red";
					this.dialog.status = true;
				});
		},
	},
	watch: {
		"busca.dtmes": function (newValue, oldValue) {
			if (this.busca.dtmes < "2022-01") {
				this.dialog.status = true;
				this.dialog.title = "Erro";
				this.dialog.msg =
					"A data não pode ser inferior a Janeiro de 2022!";
				this.dialog.icon = "mdi-alert-circle-outline";
				this.dialog.iconColor = "red";
				this.busca.dtmes = oldValue;
			} else {
				this.listarConfiguracaoMeta();
				this.listar();
			}
		},
	},
	created() { },
};
</script>

<style scoped>

.meses-bg {
  background-color: #f5f7fa;
}

.oculto-borda-lateral td:first-child {
  border-left: 1px solid #bdbdbd !important;
}
.oculto-borda-lateral td:last-child {
  border-right: 1px solid #bdbdbd !important;
}
.oculto-borda-topo td {
  border-top: 1px solid #bdbdbd !important;
}
.oculto-borda-base td {
  border-bottom: 1px solid #bdbdbd !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>